import { registerLayout, ViewType } from '@kunlun/dependencies';

registerLayout(
  `<view type="TABLE">
    <element widget="AutoAllocConsoleHistoryWidget" slot="table" slotSupport="field">
            <element widget="expandColumn" slot="expandRow" />
            <xslot name="fields" slotSupport="field" />
            <element widget="rowActions" slot="rowActions" slotSupport="action" />
        </element>
</view>`,
  {
    moduleName: 'libraCore',
    model: 'libra.inventory.TradeOrderAutoAllocInfoRecordProxy',
    viewType: ViewType.Table
  }
);